/* ============================================================
   THE SLEEP LOFT — shared reveal-on-scroll observer.
   ------------------------------------------------------------
   One IntersectionObserver for EVERY [data-sl-reveal] container
   on the page, replacing the near-identical observer that each
   custom section used to inline.

   - Adds `sl-reveal-ready` to <html> immediately, which "arms"
     the hidden initial state in sl-shared.css. If this script
     fails to load, that class is never set and all .sl-reveal
     content stays visible (no hidden above-the-fold content).
   - Adds `.sl-in` to a container when it scrolls into view; the
     CSS then animates its `.sl-reveal` children (staggered via
     each child's inline `--sl-delay`).
   - Re-scans on `shopify:section:load` so the theme editor and
     dynamically-loaded sections animate correctly.
   ============================================================ */
(function () {
  var root = document.documentElement;
  root.classList.add('sl-reveal-ready');

  var supported = 'IntersectionObserver' in window;
  var io = supported
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sl-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' })
    : null;

  function scan(scope) {
    var nodes = (scope || document).querySelectorAll('[data-sl-reveal]:not(.sl-in)');
    for (var i = 0; i < nodes.length; i++) {
      if (io) {
        io.observe(nodes[i]);
      } else {
        nodes[i].classList.add('sl-in'); // no IO support: reveal immediately
      }
    }
  }

  if (document.readyState !== 'loading') {
    scan();
  } else {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  }

  // Theme editor / dynamic section injection
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target || document);
  });
})();
